export function today() { return new Date().toISOString().slice(0, 10); }
export const CATEGORIES = ["buzağı", "düve", "inek", "tosun"];
export const CHART = ["#417251", "#C45B45", "#DDA74F", "#5A6E5F", "#8F9E93"];
